import { render, staticRenderFns } from "./tap1.vue?vue&type=template&id=0db91e37&scoped=true&"
import script from "./tap1.vue?vue&type=script&lang=js&"
export * from "./tap1.vue?vue&type=script&lang=js&"
import style0 from "./tap1.vue?vue&type=style&index=0&id=0db91e37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db91e37",
  null
  
)

export default component.exports